export default {
      id: "icon-arrow-right-no-shaft-usage",
      viewBox: "0 0 24 24",
      url: "/" + "sprite.svg#icon-arrow-right-no-shaft",
      toString: function () {
        return this.url;
      }
    }